import {
  Alert,
  Box,
  Card,
  CircularProgress,
  Container,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { deleteSingleObject, getData } from "../../../Config/FirebaseMethod";

const BookingData = () => {
  let [rows, setRows] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [userID, setUserID] = useState("");
  const [open, setOpen] = useState(false);
  let [list, setList] = useState([]);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  let FData = () => {
    setisLoading(true);
    getData(`Booking/`)
      .then((res) => {
        setisLoading(false);
        setRows(res);
        // (res);
      })
      .catch((err) => {
        setisLoading(false);
        alert(err);
      });
  };

  let deleteItem = (id, listId) => {
    deleteSingleObject(`Booking/${userID}`, listId);
    let listI = list.filter((value, index) => {
      return index !== id;
    });
    setList(listI);
    deleteSingleObject(`Booking/${userID}`, listId)
      .then((res) => {
        // window.location.reload(false);
        setOpen(true);
        setAlertSeverity("success");
        setAlertMessage("The Booking Has Been Deleted Successfully");
      })
      .catch((err) => {
        setAlertSeverity("error");
        setAlertMessage("The Booking Has Not Deleted Please Try Again Later");
        setOpen(true);
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the real-time function
        await FData();
      } catch (err) {
        // Handle any errors
        console.error(err);
      }
    };

    // Run the function initially
    fetchData();

    // Set up an interval to run the function periodically
    const interval = setInterval(fetchData, 2000); // Fetch data every 2 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <Box sx={{ overflowX: "auto" }}>
          <Card sx={{ minWidth: 32 + "%", borderRadius: 3 }}>
            <Box mt={3} justifyContent="center" textAlign="center">
              <Typography variant="h4">Appointment Data</Typography>
              <Container
                className="mt-3 mb-5"
                sx={{ maxWidth: "100%", overflowX: "auto" }}
              >
                <TableContainer
                  sx={{
                    "&::-webkit-scrollbar": { width: "0.6px", height: "0.6em" },
                    "&::-webkit-scrollbar-thumb": { backgroundColor: "#888" },
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>S.ID</TableCell>
                        <TableCell>Full Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Contact Number</TableCell>
                        <TableCell>Social Media</TableCell>
                        <TableCell>Purpose</TableCell>
                        <TableCell>Date & Time</TableCell>
                        <TableCell>Category</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, i) => (
                        <TableRow key={i}>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{row.fullname}</TableCell>
                          <TableCell>{row.email}</TableCell>
                          <TableCell>{row.purpose}</TableCell>
                          <TableCell>{row.social}</TableCell>
                          <TableCell>{row.number}</TableCell>
                          <TableCell>{row.dateTime}</TableCell>
                          <TableCell>
                            <button
                              className="btn btn-danger"
                              onClick={() => deleteItem(i, row.id)}
                            >
                              Delete
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Container>
              <Snackbar
                open={open}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
              >
                <Alert severity={alertSeverity} sx={{ width: "100%" }}>
                  {alertMessage}
                </Alert>
              </Snackbar>
            </Box>
          </Card>
        </Box>
      )}
    </div>
  );
};

export default BookingData;
